// NPM Imports
import React from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Components Imports
import ContentLock from "../ContentLock";

//
// Actions Imports
import {
  updateComponentMeta,
  updateHoveredDocumentSectionId,
  updateDocumentClickedComponentID,
} from "../../../actions/DocumentActions/index";

// Services Imports

// Internal Imports
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { COMPONENT_FEATURE, DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

export default function ComponentLockBtn({
  clauseOptionsDetails,
  handleComponentLockUnlock,
  mode,
  sectionType,
  clauseID,
  toggleUpgradePopup,
  lock,
}) {
  // mapDispatchToProps
  const dispatch = useDispatch();

  // if lock is allowed for current mode or not
  if (
    !COMPONENT_FEATURE[mode].lockSection ||
    sectionType === DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER ||
    sectionType === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER
  ) {
    return null;
  }

  // for document, show only locked section because of added clause
  if (mode === "DOCUMENT") {
    if (clauseID) {
      return (
        <Tooltip
          placement="left"
          overlay="This clause is locked for any editing.">
          <span className="btn-icon locked-icon">
            <FontAwesomeIcon icon={["far", "lock"]} />
          </span>
        </Tooltip>
      );
    }
    return null;
  }

  // Implementing feature gating for Pricing Plan
  const isDisabled = !!clauseOptionsDetails;

  const _toggleSectionLock = (event, lockFlag) => {
    event.preventDefault();
    if (!clauseOptionsDetails) {
      handleComponentLockUnlock(lockFlag);
      dispatch(updateDocumentClickedComponentID(null, true));
      dispatch(updateComponentMeta({}));
      if (sectionType === "Table") {
        dispatch(updateHoveredDocumentSectionId(null));
      }
    }
  };

  return (
    <ContentLock
      isDisabled={isDisabled}
      toggleSectionLock={_toggleSectionLock}
      toggleUpgradePopup={toggleUpgradePopup}
      lock={lock}
    />
  );
}
